import { getRouteApi } from '@tanstack/react-router'
import { CircularProgress } from 'ui/components'

import { ManageLicensePage } from '../../components/ManageLicensePage'
import { useGetLicense } from '../../hooks'

const routeApi = getRouteApi('/_app/licenses/$licenseId/edit')

const EditLicense = () => {
  const { returnUrl } = routeApi.useSearch()
  const { licenseId } = routeApi.useParams()
  const { data, isFetching } = useGetLicense({ licenseId: +licenseId, companyId: 0 })

  return (
    <>{!data || isFetching ? <CircularProgress centered /> : <ManageLicensePage data={data} returnUrl={returnUrl} />}</>
  )
}

export default EditLicense
